import * as types from '../mutation-types/auth'

// set this true to namespace all getters, mutations, actions etc.
const namespaced = true
export const namespace = 'auth'

// state
const state = {
  fbUser: null,
}

// mutations
const mutations = {
  [types.SET_FB_USER](state, payload) {
    state.fbUser = payload
  },
}

const actions = {
  setFbUser({ commit }, payload) {
    commit(types.SET_FB_USER, payload)
  },
}

// getters
const getters = {
  fbUser: state => state.fbUser,
}


const plugins = []

const auth = {namespaced, namespace, state, mutations, actions, getters, plugins}
export default auth
